import type { ExtensionComponents } from '../../common/utils/extension-components-context/types';

import { TwilioLiveChatCloseProvider } from './live-chat-close-provider';
import { TwilioLiveChatManager } from './live-chat-manager';
import { TwilioLiveChatSendMessageProvider } from './live-chat-send-provider';

export const TwilioExtensionComponents: ExtensionComponents = {
	liveChatManager: TwilioLiveChatManager,
	liveChatSendMessageProvider: TwilioLiveChatSendMessageProvider,
	liveChatCloseProvider: TwilioLiveChatCloseProvider,
};
